import React, { Component } from "react"

export default class ArticleColorUsp extends Component {
  render() {
    const titleBoxStyle = { "--title-box-color": this.props.titleBoxColor, "--title-box-text-color": this.props.titleBoxTextColor }
    const containerStyle = { "--usp-box-color": this.props.uspBoxColor, "--usp-box-text-color": this.props.uspBoxTextColor }
    return (
      <div className={this.props.modifier || ""}>
        <div className="usp-container" style={containerStyle}>
          <div className="titlebox" style={titleBoxStyle}>
            {this.props.title}
          </div>
          <div className="textcontainer">
            <div className="textboxhead" dangerouslySetInnerHTML={{ __html: this.props.headline }}></div>
            {this.props.uspTexts && this.props.uspTexts.length > 0 ? (
              <ul className="uspbox">
                {this.props.uspTexts.map((usp, index) => {
                  return <li key={index}>{usp}</li>
                })}
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    )
  }
}
